import { AddressSuggestion } from '../types/AddressSuggestion';

/**
 * Creates a unique key for an address suggestion based on street, city, state, and zipcode.
 * Used for both React keys and deduplication.
 */
export const getSuggestionKey = (suggestion: AddressSuggestion): string => {
  return `${suggestion.street_line}-${suggestion.city}-${suggestion.state}-${suggestion.zipcode}`;
};
